import React, { useState, useEffect, useMemo } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { Info,GeocoderAddress } from 'components'
import { InfoItems } from 'components/info';
import { observer } from 'mobx-react'
import './inforWindowContent.less'
import { webAPIResponse } from 'server/web/index.globals';
import { userStore } from 'store'
import { getLangMessage as f } from 'util/comm';
import { toJS } from 'mobx';
import Lnglats from 'util/lnglats'

interface inforWindowContentProps {
  id?: string
  onClose?: () => void
  info: webAPIResponse.vehiclesInfo | null
  /** 是否展示操作栏
   * @default true
   */
  showTool?: boolean
}

function InforWindowContent(props: inforWindowContentProps) {
  const { info } = props
  const [visible, setVisible] = useState<boolean>(true)

  useEffect(() => {
    setVisible(!userStore.isConcrete)
  }, [userStore.isConcrete])

  useEffect(() => {
    setVisible(props.showTool === false ? false : true)
  }, [props.showTool])

  const [item] = useState<InfoItems[]>([{
    children: [
      { dataIndex: 'plateNo', intlTitle: 'tx010001', description: '车牌号', render: (value: any) => <span>{ value }</span> },
      { dataIndex: 'depName', intlTitle: 'tx010002', description: '车队', render: (value: any) => <span>{ value }</span> },
      { dataIndex: 'plateColor', intlTitle: 'tx010003', description: '颜色', render: (value: any) => <span>{ value }</span> },
      { dataIndex: 'alarmTime', intlTitle: 'tx020003', description: '报警时间', render: (value: any) => <span>{ value }</span> },
      { dataIndex: 'alarmSourceName', intlTitle: 'tx020001', description: '报警来源', render: (value: any) => <span>{ value }</span> },
      { dataIndex: 'alarmTypeName', intlTitle: 'tx020002', description: '报警类型', render: (value: any) => <span>{ value }</span> },
      // { dataIndex: 'location', intlTitle: 'tx000106', description: '地址', row: 2, render: (value: any) => <span>{ value }</span> },
      {
        dataIndex: '_', intlTitle: 'tx000106', description: '地址', row: 2,
        // render: (_value: any, record: any) => {
        //   const records = toJS(record)
        //   const recordStr = JSON.stringify(records)
        //   return <Lnglats lnglat={recordStr && recordStr != '{}' ? [records?.longitude, records?.latitude] : [0.0, 0.0]} />
        // }
        render: (_value: any, record: any) => (
                <GeocoderAddress
                    longitude={record?.longitude}
                    latitude={record?.latitude}
                  />
          )   
      },
    ]
  }])

  const close = () => {
    if (props.onClose) {
      props.onClose()
    }
  }

  return (
    <div className='tx-infowindow'>
      <div className='infowindow-header'>
        <div className='header-title'>
          { f({ id: 'tx020061', description: '报警信息' }) }
        </div>
        <div>
          <CloseOutlined onClick={ close } />
        </div>
      </div>
      <div className='infowindow-content'>
        <Info row={ 2 } items={ item } data={ info || {} } />
      </div>
    </div>
  )
}

export default observer(InforWindowContent)
